import { type Locale } from '@taler/domain'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSession } from '@/app/session'
import { useAccountsTree } from '@/features/accounts'

/** Account names and icons for the Reports breakdowns, read from the one chart of accounts the app already loads. */
export function useReportNames() {
  const session = useSession()
  const { locale } = useI18n()
  const tree = useAccountsTree({
    ledgerId: () => session.activeLedger.value?.id,
    locale: () => locale.value as Locale,
    enabled: () => session.activeLedger.value !== undefined,
  })
  const byId = computed(() => new Map(tree.allRows.value.map((row) => [row.id, row])))

  return {
    accounts: tree.allRows,
    labelOf: (accountId: string | undefined): string | undefined =>
      accountId === undefined ? undefined : byId.value.get(accountId)?.label,
    iconOf: (accountId: string | undefined): string | undefined =>
      accountId === undefined ? undefined : byId.value.get(accountId)?.icon,
  }
}
